import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validates email with stricter rules than standard regex:
 * - No consecutive dots (..)
 * - No leading/trailing dots in local part
 * - No leading/trailing spaces
 * - Valid TLD (alpha only, 2-6 chars)
 * - Standard format: local@domain.tld
 */
export function isEmailValid(email: string): boolean {
  if (!email || !email.trim()) return false;
  const trimmed = email.trim();

  // Basic structure: must have exactly one @
  const parts = trimmed.split('@');
  if (parts.length !== 2) return false;

  const [local, domain] = parts;

  // Local part checks
  if (!local || local.startsWith('.') || local.endsWith('.') || local.includes('..')) return false;
  if (!/^[a-zA-Z0-9._%+-]+$/.test(local)) return false;

  // Domain checks
  if (!domain || domain.startsWith('.') || domain.startsWith('-')) return false;
  if (domain.includes('..')) return false;
  if (!/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(domain)) return false;

  return true;
}

/**
 * Angular ValidatorFn for reactive forms
 */
export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null; // let Validators.required handle empty
    return isEmailValid(control.value) ? null : { email: true };
  };
}
